export default "__VITE_ASSET__64a6611c__"